module Meevo.Plugins.Tippy {
    "use strict";

    export class TippyContext extends Meevo.Components.CommonClasses.CommonContextBase {

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            private $rootScope: angular.IRootScopeService,
            private tippyService: Meevo.Plugins.Tippy.TippyService,
            private meevoDataService: Meevo.Components.BaseClasses.IDataService,
            protected contextParams: Meevo.ContextParamsService
        ) {
            super(appSettings,
                dataService,
                modalService,
                identityService,
                loggingService,
                securityChecker,
                trackingService);

            this.baseEndpoint = appSettings.API_ENDPOINTS.tippy;
            this.sectionTemplatePath = "app/plugins/tippy/sectionViews/";
            this.buildCrudSecurityKeysBase(this.securityKeys.DATA_SERVICE_TAB_MAIN);
            this.initializeSections();
        }

        mainSection: MainSection;
        employeesSection: EmployeesSection;
        logSection: LogSection;
        initializeSections(): void {
            if (this.identityService.inSandboxMode()) {
                this.sections.push(new SandboxSection(3,
                    "SECTION_MAIN",
                    "sandbox.html",
                    false,
                    true,
                    this.baseEndpoint,
                    "",
                    this.loggingService,
                    this.dataService,
                    Model.NounEnum.Tippy,
                    this.identityService,
                    this.securityKeys.INTEGRATION_TIPPY + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
            }
            else {
                this.mainSection = new MainSection(0,
                    "SECTION_MAIN",
                    "main.html",
                    true,
                    false,
                    this.baseEndpoint,
                    "config",
                    this.loggingService,
                    this.dataService,
                    Model.NounEnum.Tippy,
                    this.identityService,
                    this.modalService,
                    this.tippyService,
                    this.securityKeys.INTEGRATION_TIPPY + Meevo.Components.Common.SecurityParts.KEY_PART_READ

                );
                this.sections.push(this.mainSection);
            }
            this.activate();
        }

        sectionModelRetrieved() {
            this.selectedSection.isLoaded = false;
            if (this.selectedSection === this.mainSection &&
                Model.Guard.isSomething(this.selectedSection.model.accountToken)) {
                this.addEmployeeSection();
                this.addLogSection();
            }
            this.selectedSection.sectionModelRetrieved();
        }

        sectionModelRetrievalFailure(ex) {
            if (!ex.data.skipInterceptor) {
                return;
            }
            this.modalService.alert(ex.data.message);
        }

        sectionSaved() {
            this.selectedSection.isLoaded = false;
            if (this.selectedSection === this.mainSection) {
                let index = this.sections.indexOf(this.employeesSection)
                if (Model.Guard.isNothing(this.selectedSection.model.accountToken) &&
                    index !== -1) {
                    this.sections.splice(index, 1);
                    this.employeesSection = undefined;
                }
                else if (Model.Guard.isSomething(this.selectedSection.model.accountToken) &&
                    index === -1)
                {
                    this.addEmployeeSection();
                }

                let logSectionIndex = this.sections.indexOf(this.logSection)
                if (Model.Guard.isNothing(this.selectedSection.model.accountToken) &&
                    index !== -1) {
                    this.sections.splice(logSectionIndex, 1);
                    this.logSection = undefined;
                }
                else if (Model.Guard.isSomething(this.selectedSection.model.accountToken) &&
                    index === -1)
                {
                    this.addLogSection();
                }
            }
        }

        private addEmployeeSection(): void {
            if (this.employeesSection) {
                return;
            }

            this.employeesSection = new EmployeesSection(1,
                "SECTION_EMPLOYEES",
                "employees.html",
                false,
                false,
                this.baseEndpoint,
                "employees/list?enableUnauthorizedHandling=true",
                this.loggingService,
                this.dataService,
                Model.NounEnum.Tippy,
                this.identityService,
                this.modalService,
                this.$rootScope,
                this.meevoDataService,
                this.securityKeys.INTEGRATION_TIPPY + Meevo.Components.Common.SecurityParts.KEY_PART_READ
            );
            this.sections.push(this.employeesSection);
        }

        private addLogSection(): void {
            if (this.logSection) {
                return;
            }

            this.logSection = new LogSection(2,
                "LABEL_LOG",
                "log.html",
                false,
                false,
                this.baseEndpoint,
                "config",
                this.loggingService,
                this.dataService,
                Model.NounEnum.Tippy,
                this.contextParams,
                this.identityService,
                this.securityKeys.INTEGRATION_TIPPY + Meevo.Components.Common.SecurityParts.KEY_PART_READ
            );
            this.sections.push(this.logSection);
        }

        initializeHeader(model: any): void {
            this.headerContent = model.storeName;
        }

        edit(): void {
            if (this.selectedSection === this.employeesSection) {
                this.modalService.yellowConfirm("MESSAGE_TIPPY_EMPLOYEES_EDIT").then(() => {
                    this.dataService.getSection(this.baseEndpoint, `${this.selectedSection.sectionEndpoint}&refresh=true`).then((data: any) => {
                        this.selectedSection.model = data;
                        this.sectionModelRetrieved();
                    });
                });
            }
            super.edit();
        }

        save(): angular.IPromise<any> {
            if (this.selectedSection.canSaveLogic()) {
                return super.save();
            }
            return null;
        }

        showEditLogic() {
            return this.identityService.inSandboxMode() ? false : super.showEditLogic();
        }

    }
}